"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScene = void 0;
var helpers_1 = require("../helpers");
/**
 * `useScene` is a hook that retrieves the current Scene.
 *
 * Don't use this hook if you start multiple Scenes.
 *
 * @returns Phaser.Scene
 */
function useScene() {
    return (0, helpers_1.getScene)();
}
exports.useScene = useScene;
//# sourceMappingURL=useScene.js.map